

// @ts-nocheck

import Vue from 'vue'

export default Vue.extend({
    props: {
        fieldAddress: Array
    },
    methods: {
            startVideoTrial() {
                this.$vs.loading()
                this.$store.dispatch("dash/START_VIDEO_TRIAL").then(() => {
                    //notify with notification:
                    this.$vs.notify({
                        title: 'Video trial started',
                        text: 'You can now trial video responses free for 7 days.',
                        color: 'success',
                        time: 20000,
                        iconPack: 'feather',
                        icon: 'icon-info',
                        position: 'top-center'
                    })
                }).catch(() => {
                    //notify with notification:
                    this.$vs.notify({
                        title: 'Error',
                        text: 'There was an error starting your video trial. Please reach out to support.',
                        color: 'danger',
                        time: 20000,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        position: 'top-center'
                    })
                }).finally(() => {
                    this.$vs.loading.close()
                })
        }
        },
    computed: {
        isLTDCustomer() {
            return (this.$store.state.dash.viewData.business.isAppSumo || this.$store.state.dash.viewData.business.isPitchground || this.$store.state.dash.viewData.business.isDealify || this.$store.state.dash.viewData.business.isFBLLTD)
        },
       
        field: {
            get: function (): string | false {
                return this.$store.getters["survey/stepField"](this.fieldAddress);
            },
            set: function (v: string): void {
                this.$store.commit("survey/CHANGE_FIELD", {
                    fieldAddress: this.fieldAddress,
                    val: v,
                });
            },
        }
    }
})

